import { create } from "zustand"
import { persist } from "zustand/middleware"
import type { LoginMethod } from "@/api/types/auth"

interface LoginMethodState {
  method: LoginMethod | null
  setMethod: (method: LoginMethod) => void
  clearMethod: () => void
}

export const useLoginMethodStore = create<LoginMethodState>()(
  persist(
    (set) => ({
      method: null,
      setMethod: (method) => set({ method }),
      clearMethod: () => set({ method: null }),
    }),
    {
      name: "org-login-method-storage",
    },
  ),
)
